import { useMutation, useQuery } from "@apollo/client";
import ReactTable from "react-table";
import { Card, Button, Row, Col, Modal, Input, ModalBody } from "reactstrap";
import {
  GET_MEMBERS_LIST,
  GET_SUPPORTER_CONTRACT,
} from "../../OrganizationPartnership/queries";
import { useState } from "react";
import styles from "./index.module.scss";
import { DropdownList, SelectList } from "react-widgets";
import {
  ADD_SUPPORTER_MEMBER,
  DELETE_SUPPORTER_MEMBER,
} from "../../OrganizationPartnership/mutations";
import {
  CHECK_USER_STATUS,
  GET_ORG_PROFILE,
  GET_TICKET_PACKAGES,
  QUERY_MY_SUPPORTER_INFO,
  SUPPORTER_CHECKOUT_TICKET,
} from "../../../../queries";
import { Link } from "react-router-dom";
import {
  useMyOrgInfo,
  useOrgPk,
  useUserEmail,
  useUserInfo,
} from "../../../../Layout/AppMain/LoginStatusContext";
import { toast } from "react-toastify";

const TabMembersList = () => {
  const [modalCreateOpen, setModalCreateOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [pricingModalOpen, setPricingModalOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [permission, setPermission] = useState(null);
  const {
    data: membersData,
    loading: loadingMembers,
    refetch,
  } = useQuery(GET_MEMBERS_LIST);
  const [addMember, { loading: loadingAddMember }] = useMutation(
    ADD_SUPPORTER_MEMBER,
    {
      onCompleted: (res) => {
        refetch();
        setEmail("");
        setPermission({
          id: "CAN_EDIT",
          name: "編集",
        });
        alert(res?.supporterCreateRole?.result);
      },
      onError: (error) => {
        console.log(error);
        toast.error(error.message);
      },
    }
  );
  const [deleteMember, { loading: loadingDeleteMember }] = useMutation(
    DELETE_SUPPORTER_MEMBER,
    {
      onCompleted: () => {
        refetch();
      },
    }
  );
  const userInfo = useUserInfo();
  const userId = userInfo?.id;
  const orgPk = useOrgPk();
  const { data: mySupporterData } = useQuery(QUERY_MY_SUPPORTER_INFO);

  const { data: supporterInfo } = useQuery(QUERY_MY_SUPPORTER_INFO);
  const { data: supporterContractData } = useQuery(GET_SUPPORTER_CONTRACT);
  const { data: ticketsData, loading } = useQuery(GET_TICKET_PACKAGES);
  const contractPlan = supporterContractData?.myContractInfo?.edges[0]?.node
    ?.plan ?? {
    id: null,
    name: null,
    fee: null,
  };
  const ticketsPlan = ticketsData?.allTicket?.edges;

  const { data: checkUserStatus } = useQuery(CHECK_USER_STATUS, {
    variables: {
      email: useUserEmail(),
    },
  });

  const canEdit =
    checkUserStatus?.allUsers?.edges[0]?.node?.supporterRole === "can_edit" ||
    checkUserStatus?.allUsers?.edges[0]?.node?.supporterRole === "CAN_EDIT";
  const handleAddMember = () => {
    try {
      addMember({
        variables: {
          email,
          permission: permission.id,
          supporterId: supporterInfo?.mySupporterInfo?.edges[0]?.node?.id,
        },
      });
    } catch (error) {
      console.log(error);
      toast.error(error.message);
    }
  };

  const [supporterCheckoutTicket] = useMutation(SUPPORTER_CHECKOUT_TICKET);
  const totalTicket =
    mySupporterData?.mySupporterInfo?.edges[0]?.node?.totalTicket ?? 0;
  console.log(mySupporterData?.mySupporterInfo?.edges[0]?.node);

  const handleCheckout = async (ticketId) => {
    try {
      const res = await supporterCheckoutTicket({
        variables: {
          ticketId: ticketId,
          supporterId: supporterInfo?.mySupporterInfo?.edges[0]?.node?.id,
        },
      });
      window.location.href = res?.data?.supporterCheckoutTicket?.url;
    } catch (error) {
      console.log(error);
      toast.error(error.message);
    }
  };

  const members = membersData?.mySupporterRole?.edges ?? [];
  return (
    <>
      <Card className="mb-2 org_contentarea">
        <div className="org_subtitle_sec">
          <div
            className="org_subtitle"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h4 style={{ fontSize: 16, marginBottom: 0, fontWeight: "bold" }}>
              情報開示
            </h4>
          </div>
          {canEdit && (
            <Button className="ema__btn__edit">
              <Link
                to={{
                  pathname: `/dashboards/pricing-supporter`,
                }}
                style={{ color: "#fff", textDecoration: "none" }}
              >
                プランをアップグレード
              </Link>
            </Button>
          )}
        </div>
        <div
          style={{
            padding: "24px",
          }}
        >
          <Row
            style={{
              marginBottom: "18px",
            }}
          >
            <Col sm={1}>
              <div
                style={{
                  fontWeight: "bold",
                }}
              >
                プラン
              </div>
            </Col>
            <Col sm={9}>
              <div>{contractPlan?.name}</div>
            </Col>
          </Row>
          <Row>
            <Col sm={1}>
              <div
                style={{
                  fontWeight: "bold",
                }}
              >
                料金
              </div>
            </Col>
            <Col sm={8}>
              <div>¥{contractPlan?.fee}</div>
            </Col>
          </Row>
          <Row>
            <Col sm={4}>
              <div
                style={{
                  borderTop: "1px solid #e5e5e5",
                  marginTop: "32px",
                  paddingTop: "16px",
                  maxWidth: "250px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "16px",
                  }}
                >
                  <div>チケット枚数</div>
                  <div>{totalTicket}枚</div>
                </div>
                <div>
                  <button
                    className="ema__btn__main csv__button"
                    style={{
                      display: "flex",
                      padding: "0 22px",
                      justifyContent: "center",
                      height: "40.3px",
                      alignItems: "center",
                      borderRadius: "4px",
                      marginBottom: "8px",
                    }}
                    onClick={() => {
                      setPricingModalOpen(true);
                    }}
                  >
                    追加
                  </button>
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <div className="org_subtitle_sec">
          <div
            className="org_subtitle"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h4 style={{ fontSize: 16, marginBottom: 0, fontWeight: "bold" }}>
              メンバー
            </h4>
          </div>
          {canEdit && (
            <Button
              className="ema__btn__edit"
              onClick={() => {
                setModalCreateOpen(true);
              }}
            >
              追加
            </Button>
          )}
        </div>
        <div>
          <ReactTable
            style={{
              border: "none",
            }}
            getTdProps={() => ({
              style: {
                border: "none",
              },
            })}
            getTrProps={() => ({
              style: {
                border: "none",
              },
            })}
            getTrGroupProps={() => {
              return {
                style: {
                  border: "none",
                },
              };
            }}
            getTheadTrProps={() => {
              return {
                style: {
                  border: "none",
                },
              };
            }}
            getTheadThProps={() => {
              return {
                style: {
                  border: "none",
                },
              };
            }}
            resizable={false}
            columns={[
              {
                width: 50,
                Header: "",
                Cell: ({ index }) => {
                  return <div>{index + 1}</div>;
                },
              },
              {
                Header: "名前",
                accessor: "name",
                Cell: ({ row }) => {
                  return (
                    <div>
                      {row?._original?.node?.user?.additionalInfo?.username}
                    </div>
                  );
                },
                getHeaderProps: () => ({
                  style: {
                    textAlign: "left",
                  },
                }),
              },
              {
                Header: "メールアドレス",
                accessor: "node.user.email",
                width: 300,
                getProps: () => ({
                  style: {
                    textAlign: "center",
                    justifyContent: "center",
                  },
                }),
              },
              {
                Header: "ステータス",
                accessor: "node.permission",
                getProps: () => ({
                  style: {
                    textAlign: "center",
                    justifyContent: "center",
                  },
                }),
                Cell: ({ row }) => {
                  return (
                    <div>
                      {(row?._original?.node?.permission === "CAN_EDIT" ||
                        row?._original?.node?.permission === "can_edit") && (
                        <div
                          style={{
                            fontSize: "14px",
                            color: "#49C8DF",
                            border: "1px solid #49C8DF",
                            padding: "4px 8px",
                            borderRadius: "9999px",
                            backgroundColor: "#E8FCFF",
                          }}
                        >
                          CAN_EDIT
                        </div>
                      )}
                      {(row?._original?.node?.permission === "ONLY_VIEW" ||
                        row?._original?.node?.permission === "only_view") && (
                        <div
                          style={{
                            fontSize: "14px",
                            color: "#495057",
                            border: "1px solid #495057",
                            padding: "4px 8px",
                            borderRadius: "9999px",
                            backgroundColor: "#D6D6D6",
                          }}
                        >
                          ONLY_VIEW
                        </div>
                      )}
                    </div>
                  );
                },
              },
              {
                Header: "アクション",
                accessor: "action",
                getProps: () => ({
                  style: {
                    textAlign: "center",
                    justifyContent: "center",
                  },
                }),
                Cell: ({ row }) => {
                  const disabled =
                    row?._original?.node?.user?.id ===
                    checkUserStatus?.allUsers?.edges[0]?.node?.id;
                  return canEdit ? (
                    <button
                      disabled={disabled}
                      style={{
                        textAlign: "center",
                        padding: "9px 16px",
                        borderRadius: "4px",
                        backgroundColor: disabled ? "#8c8c8c" : "#E36B6B",
                        color: "white",
                        border: "none",
                      }}
                      onClick={() => {
                        setDeleteModalOpen(true);
                        setSelectedMember(row?._original?.node);
                      }}
                    >
                      削除
                    </button>
                  ) : null;
                },
              },
            ]}
            showPagination={false}
            data={members}
          />
        </div>
      </Card>
      <Modal
        backdrop
        isOpen={modalCreateOpen}
        toggle={() => {
          setModalCreateOpen(!modalCreateOpen);
        }}
        size="xl"
        backdropClassName={styles["reverted-backdrop"]}
        className={styles["supporter-registration-modal"]}
      >
        <div
          style={{
            padding: "50px 50px",
          }}
        >
          <div>
            <div
              style={{
                fontSize: "20px",
                marginBottom: "12px",
              }}
            >
              メールアドレス
            </div>
            <div
              style={{
                display: "flex",
                gap: "12px",
              }}
            >
              <Input
                type="email"
                required={true}
                placeholder="new_member@example.com"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              />
              <DropdownList
                dataKey="id"
                textField="name"
                style={{
                  width: "150px",
                }}
                value={permission}
                onChange={(e) => {
                  setPermission(e);
                }}
                placeholder="権限"
                data={[
                  {
                    id: "CAN_EDIT",
                    name: "編集",
                  },
                  {
                    id: "ONLY_VIEW",
                    name: "閲覧",
                  },
                ]}
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              className="ema__btn__edit"
              style={{
                marginTop: "12px",
              }}
              onClick={() => {
                handleAddMember();
                setModalCreateOpen(false);
              }}
            >
              追加
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        backdrop
        isOpen={deleteModalOpen}
        toggle={() => {
          setDeleteModalOpen(!deleteModalOpen);
        }}
        size="xl"
        backdropClassName={styles["reverted-backdrop"]}
        className={styles["supporter-registration-modal"]}
      >
        <ModalBody className="mt-4 ml-3 mr-3 mb-2">
          <p className="bold">メンバーを削除します。よろしいですか？</p>
          <Button
            onClick={() => {
              setDeleteModalOpen(false);
              deleteMember({
                variables: {
                  roleId: selectedMember.id,
                },
              });
            }}
            className="main_button"
            style={{ background: "#E36B6B", border: "none" }}
          >
            削除
          </Button>
        </ModalBody>
      </Modal>
      <Modal
        isOpen={pricingModalOpen}
        toggle={() => setPricingModalOpen(!pricingModalOpen)}
        backdropClassName="reverted-backdrop"
        size="sm"
        contentClassName={styles["pricing-modal-content"]}
        className={styles["pricing-modal-dialog"]}
      >
        <ModalBody>
          <div
            style={{
              marginTop: "70px",
              marginBottom: "70px",
              textAlign: "center",
              fontSize: "20px",
            }}
          >
            チケット購入
          </div>
          <div
            style={{
              paddingLeft: "16px",
              paddingRight: "16px",
            }}
          >
            {ticketsPlan?.map((ticket, idx) => {
              return (
                <div
                  key={ticket?.node?.id}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "16px 0",
                    borderBottom: "1px solid #E0E0E0",
                    borderTop: "1px solid #E0E0E0",
                    marginBottom: idx === ticketsPlan.length - 1 ? "70px" : "0",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      fontSize: "20px",
                      gap: "16px",
                    }}
                  >
                    <div
                      style={{
                        width: "58px",
                      }}
                    >
                      {ticket?.node?.amount}枚
                    </div>
                    <div>
                      ¥
                      {String(ticket?.node?.price).toLocaleString("ja-JP", {
                        style: "currency",
                        currency: "JPY",
                      })}
                    </div>
                  </div>
                  <button
                    style={{
                      backgroundColor: "#44CAE1",
                      color: "white",
                      borderRadius: "4px",
                      border: "none",
                      padding: "12px 24px",
                    }}
                    onClick={() => handleCheckout(ticket?.node?.id)}
                  >
                    購入
                  </button>
                </div>
              );
            })}
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default TabMembersList;
